import {
  runStringExtender
} from "vue-js-extender";
runStringExtender();

import {
  ObjectEx
} from "vue-objectex";
import global_ from '@/core/global';
import emptyAvatarPath from "@/assets/profile.png";

const default_departmentData = {
  Id: 0,
  ParentId: 0,
  Name: null,
  Departments: [],
  Personnels: []
};

const default_personnelData = {
  Id: 0,
  PersonnelId: 0,
  DepartmentId: 0,
  Name: null,
  Phone: null,
  AvatarFileId: null,
  AvatarUrl: null,
  InterviewRecordingId: null,
  InterviewRecordingName: null,
  InterviewRecordingUrl: null,
  ResumeFileId: null,
  ResumeFileName: null,
  ResumeFileUrl: null,
  Comment: null,
  PositionId: 0,
  PositionName: null,
  IsRoleType: false,
  IsManager: false
};

class OrgChartNode extends ObjectEx {
  constructor(vmData) {
    if (!vmData)
      throw new Error("The parameter vmData cannot be null or empty.");

    let _originalVMData = vmData;
    let nodeType = !Object.keys(_originalVMData).contains("PersonnelId") ? global_.enumOrgNodeType.Department : global_.enumOrgNodeType.Personnel;

    let innerOptions = [{
      key: "dataId",
      value: _originalVMData.Id
    }, {
      key: "nodeType",
      value: nodeType
    }, {
      key: "label",
      value: _originalVMData.Name
    }, {
      key: "expand",
      value: true
    }, {
      key: "childrenDepartment",
      value: []
    }, {
      key: "childrenPersonnel",
      value: []
    }, {
      key: "childrenPersonnelEx",
      value: []
    }];

    let parentDataId = null;
    let meta = {};
    if (nodeType !== global_.enumOrgNodeType.Personnel) {
      if (!!_originalVMData["ParentId"]) {
        parentDataId = _originalVMData.ParentId;
      }
    } else {
      parentDataId = _originalVMData.DepartmentId;
      meta.personnelId = _originalVMData.PersonnelId;
      meta.phone = _originalVMData.Phone;
      meta.avatarFileId = _originalVMData.AvatarFileId;
      meta.avatarUrl = _originalVMData.AvatarUrl;
      meta.interviewRecordingId = _originalVMData.InterviewRecordingId;
      meta.interviewRecordingName = _originalVMData.InterviewRecordingName;
      meta.interviewRecordingUrl = _originalVMData.InterviewRecordingUrl;
      meta.resumeFileId = _originalVMData.ResumeFileId;
      meta.resumeFileName = _originalVMData.ResumeFileName;
      meta.resumeFileUrl = _originalVMData.ResumeFileUrl;
      meta.comment = _originalVMData.Comment;
      meta.positionId = _originalVMData.PositionId;
      meta.isRoleType = _originalVMData.IsRoleType;
      meta.isManager = _originalVMData.IsManager;
    }

    if (!!parentDataId) {
      innerOptions.push({
        key: "parentDataId",
        value: parentDataId
      }, {
        key: "parentNodeType",
        value: global_.enumOrgNodeType.Department
      });
    }

    innerOptions.push({
      key: "meta",
      value: meta
    });

    let innerFuncExtensions = {
      setToChildrenPersonnelEx(node, targetNode = this) {
        if (!!node.meta && node.meta.isManager)
          return;

        if (targetNode.childrenPersonnelEx.length === 0) {
          targetNode.childrenPersonnelEx.push(node);
          return;
        }

        this.setToChildrenPersonnelEx(node, targetNode.childrenPersonnelEx[0]);
      }
    };

    let innerDefineProps = {
      originalData: {
        get() {
          return _originalVMData;
        }
      },
      id: {
        get() {
          return `${this.dataId}|${this.nodeType}`;
        },
        set(value) {
          let dataId = 0;
          let nodeType = global_.enumOrgNodeType.Department;
          if (Object.typeOf(value) === "string" && value.contains("|")) {
            let idParts = value.split("|");
            dataId = idParts[0].toNumber();
            nodeType = idParts[1].toNumber();
          }
          this.dataId = dataId;
          this.nodeType = nodeType;
        }
      },
      pid: {
        get() {
          let parentDataId = `${this.parentDataId}`.toNumber();
          let parentNodeType = `${this.parentNodeType}`.toNumber();
          if (!parentNodeType)
            parentNodeType = global_.enumOrgNodeType.Department;

          return `${parentDataId}|${parentNodeType}`;
        },
        set(value) {
          let dataId = 0;
          let nodeType = global_.enumOrgNodeType.Department;
          if (Object.typeOf(value) === "string" && value.contains("|")) {
            let idParts = value.split("|");
            dataId = idParts[0].toNumber();
            nodeType = idParts[1].toNumber();
          }
          this.parentDataId = dataId;
          this.parentNodeType = nodeType;
        }
      },
      manager: {
        get() {
          if (!this.childrenPersonnel)
            return null;

          return this.childrenPersonnel.find(item => !!item.meta && item.meta.isManager);
        }
      },
      children: {
        get() {
          let result = [];

          result = result.concat(this.childrenPersonnelEx);
          result = result.concat(this.childrenDepartment);

          return result;
        }
      },
      avatarPath: {
        get() {
          if (!!this.meta && !!this.meta.avatarUrl) {
            return this.meta.avatarUrl;
          }

          return emptyAvatarPath;
        }
      }
    };

    super(innerOptions, innerFuncExtensions, innerDefineProps);
  }
}

OrgChartNode.blobSasKey = null;

OrgChartNode.convertBlobUrl = (originalUrl) => {
  if (!originalUrl)
    return String.empty;

  if (!OrgChartNode.blobSasKey || originalUrl.contains(OrgChartNode.blobSasKey))
    return originalUrl;

  return `${originalUrl}${OrgChartNode.blobSasKey}`;
};

OrgChartNode.createDepartmentNode = (parentNode = null) => {
  let departmentData = Object.clone(default_departmentData);
  if (!!parentNode)
    departmentData.ParentId = parentNode.id;

  return new OrgChartNode(departmentData);
}

OrgChartNode.createPersonnelNode = (parentNode = null) => {
  let personnelData = Object.clone(default_personnelData);
  if (!!parentNode)
    personnelData.DepartmentId = parentNode.id;

  return new OrgChartNode(personnelData);
}

export {
  OrgChartNode
}



// WEBPACK FOOTER //
// ./src/components/orgChart/orgChartNode.js